import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import { string, bool, number } from "prop-types";

import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import * as i18n from "util/i18n";
import * as configUtils from "util/config";

import HideInput from "pages/_components/fields/credentials/HideInput";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import Captcha from "pages/_components/fields/credentials/Captcha";
import { resizableRoute } from "pages/_components/Resizable";
import { Mixpanel } from "util/clickstreaming";

import LoginFooter from "pages/onboarding/footer";
import Logo from "./Logo";

const FORM_ID = "login.step2";

class Step2Content extends Component {
    static propTypes = {
        isMobileNative: bool.isRequired,
        securitySeal: number.isRequired,
        securitySealAlt: string.isRequired,
        isDesktop: bool.isRequired,
        showCaptcha: bool.isRequired,
        isSubmitting: bool.isRequired,
    };

    render() {
        const { securitySeal, securitySealAlt, showCaptcha, isMobileNative, isDesktop, isSubmitting } = this.props;
        return (
            <Form className="login-desktop-wrapper container--layout">
                {isDesktop && (
                    <div className="text-center mb-8">
                        <Logo className="svg-image logo logo-large" />
                    </div>
                )}
                <I18n
                    component="h1"
                    componentProps={{ className: "text-center mb-8" }}
                    id="onboarding.login.step2.isThisYourImage"
                    defaultValue="¿Esta es tu imagen de seguridad?"
                />
                <div className="text-lead security-image">
                    <div id="figureId" className="img">
                        <figure>
                            <img src={securitySeal} alt={i18n.get(securitySealAlt)} />
                        </figure>
                    </div>
                    <p id="verifyImage">
                        <I18n id="login.step2.verifyYourImage" />
                    </p>
                </div>
                <Field
                    idForm={FORM_ID}
                    name="password"
                    copyEnabled={false}
                    component={HideInput}
                    autoFocus
                    hidePlaceholder
                    autoComplete="off"
                    autoCorrect="off"
                    spellCheck="false"
                    aria-autocomplete="none"
                />
                {showCaptcha && !isMobileNative && <Field idForm={FORM_ID} name="captcha" component={Captcha} />}
                <div className="form-group mb-8">
                    <Button type="submit" bsStyle="primary" label="global.continue" loading={isSubmitting} />
                </div>
                <Link className="flex content-center mb-8" to="/recovery/password/step1">
                    <I18n
                        componentProps={{ className: "font-weight-500" }}
                        id="login.step2.forgetMyPassword"
                        defaultLabelText="Recuperar mi contraseña"
                    />
                </Link>
                <LoginFooter />
            </Form>
        );
    }
}

const mapStateToProps = (state) => ({
    securitySeal: loginSelectors.getSecuritySeal(state),
    securitySealAlt: loginSelectors.getSecuritySealAlt(state),
    showCaptcha: loginSelectors.getShowCaptcha(state),
});

export default compose(
    connect(mapStateToProps),
    resizableRoute,
    withFormik({
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: () => ({
            password: "",
            captcha: "",
        }),
        validationSchema: ({ isMobileNative, showCaptcha }) =>
            Yup.object().shape({
                password: Yup.string().required(i18n.get(`${FORM_ID}.password.required`)),
                captcha:
                    !isMobileNative && showCaptcha
                        ? Yup.string().required(i18n.get(`${FORM_ID}.captcha.required`))
                        : Yup.string(),
            }),
        handleSubmit: ({ password, captcha }, formikBag) => {
            if (
                configUtils.get("core.sessionHandler.componentFQN") ===
                "com.technisys.omnichannel.core.session.DbSessionHandler"
            ) {
                formikBag.props.dispatch(loginActions.loginStep2(password, captcha, formikBag));
            } else {
                formikBag.props.dispatch(loginActions.oauth(password, captcha, formikBag));
            }
            Mixpanel.track(FORM_ID);
        },
    }),
)(Step2Content);
